/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

import * as t from 'ts-schema';
export const adminCollectionListingDetailsSchema = t.object({
  canonicalUrl: t.optional(t.string),
  description: t.string,
  displayed: t.boolean,
  htmlPageTitle: t.string,
  id: t.number,
  metaDescription: t.string,
  name: t.string,
  slug: t.string,
  tagline: t.string,
  title: t.string,
  updatedAt: t.number,
  updatedBy: t.string
});
export const adminCollectionResponseSchema = t.object({
  draftListing: t.optional(adminCollectionListingDetailsSchema),
  id: t.number,
  internalName: t.string,
  pendingSubmission: t.boolean,
  publishedListing: t.optional(adminCollectionListingDetailsSchema),
  marketplaceType: t.union(t.literal('STANDARD'), t.literal('EMBEDDED')),
  type: t.union(t.literal('STATIC'), t.literal('DYNAMIC'))
});
export const adminCollectionsResponseSchema = t.object({
  collections: t.array(adminCollectionResponseSchema)
});
export const errorDetailSchema = t.object({
  code: t.optional(t.string),
  in: t.optional(t.string),
  message: t.string,
  subCategory: t.optional(t.string),
  context: t.optional(t.record(t.string, t.array(t.string)))
});
export const errorSchema = t.object({
  category: t.string,
  correlationId: t.string,
  message: t.string,
  subCategory: t.optional(t.string),
  context: t.optional(t.record(t.string, t.array(t.string))),
  errors: t.optional(t.array(errorDetailSchema)),
  links: t.optional(t.record(t.string, t.string))
});

/** get-/marketplace/quality/v1/self-serve/apps/collections <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: internal ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:AppCollectionsResource+type:symbol+getAll&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-App_Collections-get-%2Fmarketplace%2Fquality%2Fv1%2Fself-serve%2Fapps%2Fcollections'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/private.hubapi.com%2Fmarketplace%2Fquality%2Fv1%2Fself-serve%2Fapps%2Fcollections?showRequestDetails=true&body=&authType=internal)</span></span><span style='padding-left: 12px'></span></span> */
export const getCollectionsResponseSchema = adminCollectionsResponseSchema;
export const getCollectionsFailureSchema = errorSchema;